/**
 * FAQ URL helpers.
 *
 * DB ``question`` values often end with "?". We keep that text as-is for
 * display/storage, but omit trailing "?" from path segments so sitemaps and
 * Google do not index ``...%3F`` URLs.
 */

export function faqPathSlug(question) {
  let q = String(question || '').trim()
  while (q.endsWith('?')) {
    q = q.slice(0, -1).trimEnd()
  }
  return q.replace(/ /g, '-')
}

export function faqPathToLookupQuestion(pathSegment) {
  let q = String(pathSegment || '')
  try {
    q = decodeURIComponent(q)
  } catch (e) {
    // keep raw segment if decode fails
  }
  while (q.endsWith('?') || q.toUpperCase().endsWith('%3F')) {
    if (q.endsWith('?')) {
      q = q.slice(0, -1)
    } else {
      q = q.slice(0, -3)
    }
    q = q.trimEnd()
  }
  return q.replace(/-/g, ' ')
}
